import { InjectionToken } from '@angular/core';

import { SystemInfoTabPlugin } from '../interfaces';

/**
 * Multi-Provider-Token für Tabs auf der `/system/info`-Seite.
 * Module registrieren ihren Tab via `{ provide: SYSTEM_INFO_TAB_PLUGIN, multi: true, useFactory: ... }`.
 */
export const SYSTEM_INFO_TAB_PLUGIN = new InjectionToken<SystemInfoTabPlugin[]>('SystemInfoTabPlugin');
